import { SCAN_WINDOWS, type MarketStanceKey, type ScanWindow } from 'shared';

import type { HorizonOption } from '../components/ui/HorizonSelector';

const WINDOW_CAPTIONS: Record<ScanWindow, string> = {
  '1W': 'Fast',
  '1M': 'Swing',
  '3M': 'Trend',
  '6M': 'Cycle',
  '1Y': 'Long',
};

export const SCAN_HORIZON_OPTIONS: ReadonlyArray<HorizonOption<ScanWindow>> = SCAN_WINDOWS.map(
  (window) => ({ value: window, label: window, caption: WINDOW_CAPTIONS[window] }),
);

export const compactDollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function formatSignedPct(value: number): string {
  return `${value > 0 ? '+' : ''}${value.toFixed(1)}%`;
}

export const STANCE_STYLES: Record<MarketStanceKey, { text: string; border: string }> = {
  AGGRESSIVE: { text: 'text-success', border: 'border-l-success' },
  CONSTRUCTIVE: { text: 'text-success', border: 'border-l-success' },
  DEFENSIVE: { text: 'text-warn', border: 'border-l-warn' },
  RISK_OFF: { text: 'text-danger', border: 'border-l-danger' },
  UNKNOWN: { text: 'text-text-muted', border: 'border-l-border' },
};
